module.exports = __webpack_public_path__ + "static/media/google-final.0f2b5068.svg";